import React from 'react';
import { UseAuth } from '../contexts/auth.context';
import { useHistory } from 'react-router-dom';
const Logout = function () {
    let auth = UseAuth();
    let history = useHistory();
    if (history.location.pathname === '/logout') {
        auth.logout()
            .then(() => {
                history.push('/');
            })
            .catch(() => {
                history.push('/');
            });
    }

    return (
        <div id="login-container">
            <h1 className="h2 text-dark text-center push-top-bottom animation-slideDown">
                <i className="fa fa-cube"></i> <strong>Logging Out...</strong>
            </h1>
        </div>
    );
};
export default Logout;
